import React,{useContext} from 'react'
import { Link } from 'react-router-dom'
import { LanguageContext } from '../../LanguageContext';

function Main({title, titleHi=title, subtitle, subtitleHi=subtitle}) {
    const {language, setLanguage} = useContext(LanguageContext);
    return (
    <>
        <section className="breadcrumb-area d-flex  p-relative align-items-center" style={{ backgroundImage: "url(assets/img/bg/bg-iittp-small.jpg)" }} >
            <div className="container">
                <div className="row align-items-center">
                <div className="col-xl-12 col-lg-12">
                    <div className="breadcrumb-wrap text-left">
                    <div className="breadcrumb-title">
                        {/* <h2> { language==='en' ? subtitle.charAt(0).toUpperCase() + subtitle.slice(1).toLowerCase() : subtitleHi } </h2> */}
                        <h2> { language==='en' ? subtitle : subtitleHi } </h2>
                    </div>
                    </div>
                </div>
                <div className="breadcrumb-wrap2">
                    <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/"> { language==='en' ? title : titleHi } </Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {/* { language==='en' ? subtitle.charAt(0).toUpperCase() + subtitle.slice(1).toLowerCase() : subtitleHi } */}
                            { language==='en' ? subtitle : subtitleHi }
                        </li>
                    </ol>
                    </nav>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main;